import { IBaseInsightTextInterface } from './components/base-insight';

export const flow1 = [
  {
    progressMain: '#EA4335',
    progressBg: '#FAD2CF',
    color: '#CEEAD6',
    bg: 'rgb(92,185,117)',
    src: '/images/question_1.png',
    questionKey: 'q1',
    headerText: 'Which best describes your organization?',
    type: 'select',
    help: '',
    options: [
      { text: 'Retail', value: 1 },
      { text: 'Consumer Packaged Goods', value: 2 },
      { text: 'Manufacturing', value: 3 },
      { text: 'Logistics & Transportation', value: 4 },
      { text: 'Healthcare & Life Sciences', value: 5 },
      { text: 'Other', value: 6 },
    ] as Array<{ text: string; value: number }>,
    insight: {
      lines: [
        {
          isHighlihted: true,
          text: '88% of businesses admit they had lost orders in 2020,',
        },
        {
          isHighlihted: false,
          text:
            ' and a quarter of these say they “really don’t know how many orders they are losing.”',
        },
      ] as IBaseInsightTextInterface[],
      cite: 'Association for Supply Chain Management',
      href: `https://www.ascm.org/eiu-benchmark/ `,
    },
  },
  {
    progressMain: '#FBBC05',
    progressBg: '#FEEFC3',
    color: '#FAD2CF',
    bg: 'rgb(242,143,134)',
    src: '/images/question_2.png',
    questionKey: 'q2',
    headerText:
      'How would you characterize your supply chain and logistics data management systems and processes today?',
    type: 'select',
    options: [
      {
        text:
          'Lack of enterprise-level data visibility,  availability and analysis',
        value: 1,
      },
      {
        text:
          'Data analysis is done in siloes and supports limited process objectives',
        value: 2,
      },
      {
        text:
          'Data management platforms are available across the organization and comply with a shared set of standards',
        value: 3,
      },
      {
        text:
          'Data is captured and analyzed across the supply chain network generating cross-functional insights and improving supply chain performance',
        value: 4,
      },
    ] as Array<{ text: string; value: number }>,
    help: ``,
    insight: {
      lines: [
        { isHighlihted: true, text: 'Over half of businesses worldwide' },
        {
          isHighlihted: false,
          text: ' lack end-to-end visibility into their supply chains.',
        },
      ] as IBaseInsightTextInterface[],
      addInfo: true,
      cite: 'Association for Supply Chain Management',
      href: `https://www.ascm.org/eiu-benchmark/ `,
    },
  },
  {
    progressMain: '#4285F4',
    progressBg: '#D2E3FC',
    color: '#FEEFC3',
    bg: 'rgb(253,214,99)',
    src: '/images/question_3.png',
    questionKey: 'q3',
    headerText: 'What information is disjointed or hard for you to analyze?',
    type: 'multi-select',
    options: [
      {
        text:
          'Internal, disparate data, e.g. multiple ERPs, supply chain systems, financial records ',
        value: 1,
      },
      {
        text:
          'Your trading partners’ data, e.g. logistics partners, raw material producers',
        value: 2,
      },
      { text: 'External data, e.g. global events, weather', value:3},
    ] as Array<{ text: string; value: number }>,
    help: 'Select all that are relevant',
    insight: {
      lines: [
        {
          isHighlihted: false,
          text:
            'The digital transformation of manufacturing and supply operations is a key focus for enterprises, with a',
        },
        { isHighlihted: true, text: '  20% productivity gain expected ' },
        {
          isHighlihted: false,
          text: 'to come from digital technologies and AI.',
        },
      ] as IBaseInsightTextInterface[],
      cite: 'McKinsey Global Institute',
      href: 'https://www.mckinsey.com/business-functions/operations/our-insights/ops-4-0-fueling-the-next-20-percent-productivity-rise-with-digital-analytics',
    },
  },
  {
    progressMain: '#34A853',
    progressBg: '#CEEAD6',
    color: '#CEEAD6',
    bg: 'rgb(92,185,117)',
    src: '/images/question_4.png',
    questionKey: 'q4',
    headerText: 'What data do you use to shape demand?',
    type: 'multi-select',
    options: [
      { text: 'Past demand', value: 1 },
      { text: 'Price elasticity', value: 2 },
      { text: 'Promotion planning', value: 3 },
      { text: 'External social media trends', value: 4 },
    ] as Array<{ text: string; value: number }>,
    help: `Select all that are relevant.`,
    insight: {
      lines: [
        {
          isHighlihted: false,
          text:
            'Real-time consumer behavior is hard to track, but product availability is the',
        },
        { isHighlihted: true, text: ' #1 reason' },
        {
          isHighlihted: false,
          text: ' consumers switch brands.',
        },
      ] as IBaseInsightTextInterface[],
      cite: 'What COVID-19 did to customer loyalty',
      href:
        'https://www.retaildive.com/news/what-covid-19-did-to-customer-loyalty/583377/',
    },
  },

  {
    progressMain: '#EA4335',
    progressBg: '#FAD2CF',
    color: '#FAD2CF',
    bg: 'rgb(242,143,134)',
    src: '/images/question_5.png',
    questionKey: 'q5',
    headerText:
      'What data are you leveraging to build resiliency and sustainability into your supply chains?',
    type: 'multi-select',
    options: [
      { text: 'Natural risks data', value: 1 },
      {
        text:
          'Operational risks data, e.g. core product components dependencies and availability',
        value: 2
      },
      { text: 'Financials risks data', value: 3 },
      { text: 'Greenhouse gas emissions levels', value: 4 },
      {
        text: 'Circular economy data, e.g. data to design out waste and pollution',
        value: 5
      },
      { text: 'Social responsibility reporting data', value: 6 }
    ] as Array<{ text: string; value: number }>,
    help: `Select all that are relevant`,
    insight: {
      lines: [
        {
          isHighlihted: false,
          text:
            '"Working with Google Cloud, UPS was able to design routing software that tells the delivery driver exactly where to go, every step of the way. ',
        },
        {
          isHighlihted: true,
          text:
            'The routing software saves the company up to $400 million a year',
        },
        {
          isHighlihted: false,
          text: ', and reduces fuel consumption by 10 million gallons a year."',
        },
      ] as IBaseInsightTextInterface[],
      cite:
        'UPS uses Google Cloud to build the global smart logistics network of the future',
      href:
        'https://cloud.google.com/blog/topics/customers/ups-uses-google-cloud-to-build-the-global-smart-logistics-network-of-the-future',
    },
  },
  {
    progressMain: '#FBBC05',
    progressBg: '#FEEFC3',
    color: '#FAD2CF',
    bg: 'rgb(242,143,134)',
    src: '/images/question_5.png',
    questionKey: 'q6',
    headerText:
      'How proficient is your organization with using AI to conduct simulations for inventory decisions and horizon inventory planning? ',
    type: 'slider',
    help: `(1 being no knowledge, 5 being very comfortable)`,
    insight: {
      lines: [
        {
          isHighlihted: false,
          text: 'Manufacturers say they tap AI for ',
        },
        { isHighlihted: true, text: 'supply chain management ' },
        {
          isHighlihted: false,
          text: '(36%),',
        },
        {
          isHighlihted: true,
          text: ' risk management ',
        },
        { isHighlihted: false, text: '(36%), and ' },
        {
          isHighlihted: true,
          text: 'inventory management',
        },
        {
          isHighlihted: false,
          text: ' (34%).',
        },
      ] as IBaseInsightTextInterface[],
      cite: 'Research on AI trends in manufacturing',
      href:
        'https://cloud.google.com/blog/products/ai-machine-learning/research-on-ai-trends-in-manufacturing',
    },
  },

  {
    progressMain: '#4285F4',
    progressBg: 'rgb(254, 239, 195)',
    color: '#D2E3FC',
    bg: 'rgb(140,181,248)',
    src: '/images/question_7.png',
    questionKey: 'q7',
    headerText: 'How do you optimize your fulfillment?',
    type: 'select-fw',
    options: [
      { text: 'Using basic scenario planning', value: 1 },
      {
        text:
          'Using scenario planning based on wider insights across partner data, e.g. a 3PL or 4PL partner',
        value: 2,
      },
      {
        text:
          'Switching to supply chain twins to ensure data transparency & collaboration',
        value: 3,
      },
      {
        text:
          'Using AI simulation & recommendations to proactively adapt to changes in the market',
        value: 4,
      },
      {
        text:
          'Enabling communication across partners and optimize fulfillment processes',
        value: 5,
      },
    ] as Array<{ text: string; value: number }>,
    help: '',
    insight: {
      lines: [
        {
          isHighlihted: false,
          text:
            'Machine learning can identify probabilistic matches—data that is likely to be associated with the same person or company but that appears in slightly different formats—across databases. GE has used this technology to integrate supplier data and has ',
        },
        {
          isHighlihted: true,
          text: 'saved $80 million in its first year',
        },
        {
          isHighlihted: false,
          text:
            ' by eliminating redundancies and negotiating contracts that were previously managed at the business unit level.',
        },
      ] as IBaseInsightTextInterface[],
      cite: 'HBR - Artificial Intelligence for the Real World',
      href:
        'https://hbr.org/2018/01/artificial-intelligence-for-the-real-world',
    },
    last: true,
  },
] as const;
